import { render, staticRenderFns } from "./PayerDetailsPopover.vue?vue&type=template&id=320746c3&scoped=true"
import script from "./PayerDetailsPopover.vue?vue&type=script&lang=js"
export * from "./PayerDetailsPopover.vue?vue&type=script&lang=js"
import style0 from "./PayerDetailsPopover.vue?vue&type=style&index=0&id=320746c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320746c3",
  null
  
)

export default component.exports